import { vuexfireMutations, firestoreAction } from "vuexfire";
import { db } from "@/plugins/db.js";

export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    events: [],
    eventProfile: {}
  },

  mutations: {
    ...vuexfireMutations
  },
  actions: {
    bindCalendar: firestoreAction(context => {
      return context.bindFirestoreRef(
        "events",
        db.collection("calendar").orderBy("start", "asc")
      );
    }),
    bindEquipmentEvents: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "events",
        db
          .collection("calendar")
          .where("equipmentProfile", "==", db.doc(`equipments/${id}`))
          .where("disabled", "==", false)
      );
    }),
    bindAnEvent: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "eventProfile",
        db.collection("calendar").doc(id)
      );
    })
  },
  getters: {}
};
